import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'

import MainPagetitle from '../../layouts/MainPagetitle';

import AdminUtilizationService from '../../api/services/AdminUtilizationService';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
const Home = () => {
	const navigate = useNavigate();
	const [dashboard, setDashboard] = useState([]);
	const [isLoading, setisloading] = useState(true);
	const [currentPage, setCurrentPage] = useState(1);
	const recordsPage = 50;
	const lastIndex = currentPage * recordsPage;
	const firstIndex = lastIndex - recordsPage;
	const records = dashboard.slice(firstIndex, lastIndex);
	const npage = Math.ceil(dashboard.length / recordsPage)
	const number = [...Array(npage + 1).keys()].slice(1)
	const currentYear = new Date().getFullYear(); // Get the current year
	// const startYear = currentYear; // 5 years before the current year
	const startYear = Math.min(currentYear, 2024); // Make sure 2024 is included

	const endYear = currentYear + 10; // 5 years after the current year
	const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);
	const [selectedYear, setSelectedYear] = useState(currentYear);

	useEffect(() => {
		if (localStorage.getItem("admintoken")) {
			console.log(localStorage.getItem("admintoken"))
			getdashboard();
		}
		else {
			navigate('/')
		}
	}, []);
	function prePage() {
		if (currentPage !== 1) {
			setCurrentPage(currentPage - 1)
		}
	}

	function changeCPage(id) {
		setCurrentPage(id);
	}

	function nextPage() {
		if (currentPage !== npage) {
			setCurrentPage(currentPage + 1)
		}
	}
	const getdashboardByYear = async (e) => {
		try {
			const year = e.target.value;
			setSelectedYear(year); // Update the selected year in the state

			let dashboard = await AdminUtilizationService.index(e.target.value).json();
			if (dashboard.status === true) {
				setDashboard(dashboard.data);
				setisloading(false);
			}
			else {
				navigate('/')
			}

		} catch (error) {
			if (error.name === 'HTTPError') {
				const errorJson = await error.response.json();
				if (errorJson.message === "Unauthenticated.") {

					localStorage.removeItem("admintoken")
				}
				console.log(localStorage.getItem("admintoken"), errorJson.message)

			}



		}
	};
	const getdashboard = async (e) => {
		try {

			let dashboard = await AdminUtilizationService.index(currentYear).json();
			if (dashboard.status === true) {
				setDashboard(dashboard.data);
				setisloading(false);
			}
			else {
				navigate('/')
			}

		} catch (error) {
			if (error.name === 'HTTPError') {
				const errorJson = await error.response.json();
				if (errorJson.message === "Unauthenticated.") {

					localStorage.removeItem("admintoken")
				}


			}



		}
	};


	return (
		<>
			<MainPagetitle mainTitle="Dashboard" pageTitle={'Dashboard'} parentTitle={'Home'} />

			<div className="container-fluid">
				<div className="row">
					<div className="col-xl-12">
						<div className="card">
							<div className="card-body p-0">
								<div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
									<div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
										<h4 className="heading mb-0">Welcome Admin</h4>
										<div>
											<Link to="https://analytics.google.com/" target="_blank" className="btn btn-primary btn-sm ms-1">Google console</Link> {" "}
										</div>

									</div>
									<div style={{ display: "flex", alignItems: "center", marginLeft: "20px", marginBottom: "20px", maxWidth: "150px" }}>
										<span><b>Year</b></span>
										<select
											style={{ maxWidth: "100px", marginLeft: "20px" }}
											className="form-control"
											id="val-skill"
											name="camper_id"
											value={selectedYear} // Control the value of the dropdown based on selectedYear state
											onChange={getdashboardByYear}
										>
											{years.map((year) => (
												<option key={year} value={year}>
													{year}
												</option>
											))}
										</select>
									</div>
									<div id="employee-tbl_wrapper" className="dataTables_wrapper no-footer">
										<table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0">
											<thead  >
												<tr >
													<th>No.</th>
													<th>Title</th>
													<th>Total Nights</th>
													{/* <th>Camper Type</th> */}
													<th style={{ textAlign: 'left' }}>Total Utilization(%)</th>
													<th style={{ textAlign: 'left' }}>Total Revenue(€)</th>

												</tr>
											</thead>
											<tbody>
												{
													records.length > 0 ? (

														records.map((item, index) => (
															<tr key={index} >
																<td><span>{index + 1}</span></td>
																<td >
																	<div className="products">
																		<div>
																			<h6>{item ? item.camper.title : ''}</h6>
																		</div>
																	</div>
																</td>
																<td>
																	<div className="products">
																		<div>
																			<h6>{item ? item.totalDays : ''}</h6>
																		</div>
																	</div>
																</td>

																<td>
																	<div className="products">
																		<div>
																			<h6>{item ? item.total_utilization_percentage + " %" : ''}</h6>
																		</div>
																	</div>
																</td>

																<td>
																	<div className="products">
																		<div>
																			<h6>{item ? item.total_revenue + " €" : ''}</h6>
																		</div>
																	</div>
																</td>
															</tr>
														  ))
														) : (
														  <tr>
															<td colSpan="5" style={{ textAlign: 'center' }}>Data Not Found</td>
														  </tr>
														)}
														
											</tbody>
										</table>

									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{isLoading && <LogoAnimationLoader />}
		</>
	)
}
export default Home;